import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=7271a1ef&scoped=true"
import script from "./NoticeForm.vue?vue&type=script&lang=js"
export * from "./NoticeForm.vue?vue&type=script&lang=js"
import style0 from "./NoticeForm.vue?vue&type=style&index=0&id=7271a1ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7271a1ef",
  null
  
)

export default component.exports